module.exports = __webpack_public_path__ + "img/ca-logo-2021-320x128.a7cad234.png";